export class TextUtils {
    public firstHalf: string;
    public secondHalf: string;

    constructor(html: string) {
        let convertedHtml: string = html.toLowerCase();
        let targetAdPlacementArea: number = Math.floor(convertedHtml.length / 5);

        if (typeof window !== 'undefined') {
            const theWidth = window.innerWidth;

            if (theWidth < 400 && targetAdPlacementArea > 800) {
                targetAdPlacementArea = 800;
            }
            if (theWidth >= 400 && theWidth < 500 && targetAdPlacementArea > 1000) {
                targetAdPlacementArea = 1000;
            }
            if (theWidth >= 500 && theWidth < 600 && targetAdPlacementArea > 1200) {
                targetAdPlacementArea = 1200;
            }
            if (theWidth >= 600 && theWidth < 800 && targetAdPlacementArea > 1500) {
                targetAdPlacementArea = 1500;
            }
            if (theWidth >= 800 && theWidth < 1000 && targetAdPlacementArea > 2000) {
                targetAdPlacementArea = 2000;
            }
            if (theWidth >= 1000 && theWidth < 1200 && targetAdPlacementArea > 2500) {
                targetAdPlacementArea = 2500;
            }
            if (theWidth >= 1200 && targetAdPlacementArea > 3000) {
                targetAdPlacementArea = 3000;
            }
        } else {
            if (targetAdPlacementArea > 4000) {
                targetAdPlacementArea = 4000;
            }
        }


        let adPlacementArea: number = convertedHtml.indexOf("<p", targetAdPlacementArea);
        let tableLocation: number = convertedHtml.indexOf("<table");

        if (adPlacementArea < 0 && tableLocation < 0) {
            adPlacementArea = convertedHtml.indexOf("</span>", targetAdPlacementArea);
            if (adPlacementArea > 500) {
                adPlacementArea = adPlacementArea + 7;
                this.firstHalf = html.substring(0, adPlacementArea - 1);
                this.secondHalf = html.substring(adPlacementArea);
                return;
            }
        }

        if (tableLocation >= 0 && tableLocation < adPlacementArea) {
            if (tableLocation < 500 && html.length > 1500) {
                let endOftable = convertedHtml.lastIndexOf("</table>");
                if (tableLocation < adPlacementArea && endOftable > adPlacementArea) {
                    adPlacementArea = endOftable;
                    adPlacementArea = adPlacementArea + 8;
                    adPlacementArea = convertedHtml.indexOf("</p>", adPlacementArea);
                }
                this.firstHalf = html.substring(0, adPlacementArea);
                this.secondHalf = html.substring(adPlacementArea);
                return;
            } else {
                adPlacementArea = tableLocation;
            }
        }
        let endingTagLocation: number = convertedHtml.lastIndexOf("</", adPlacementArea - 5);
        let lastTag: string = convertedHtml.substring(endingTagLocation, 3);
        this.firstHalf = convertedHtml.substring(0, adPlacementArea - 1);

        if (lastTag !== "</p") {
            adPlacementArea = this.firstHalf.lastIndexOf("</p");
            this.firstHalf = html.substring(0, adPlacementArea - 1);
        } else {
            this.firstHalf = html.substring(0, adPlacementArea - 1);
        }
        this.secondHalf = html.substring(adPlacementArea);
    }
}